module.exports = __webpack_public_path__ + "img/swve_voll_buendelung.f389c811.png";